<div class="dialogContainer">
  <div class="header">
    <h2>Line {{ entityLine.lineId }} Summary</h2>
  </div>
  <div class="content">
    <div class="inputRow">
      <span class="labelSpan">
        <label>PRN:</label>
      </span>
      <textarea class="noresize inputField" rows="3" cols="80" readonly [value]="entityLine.prn"></textarea>
    </div>
    <div class="inputRow">
      <span class="labelSpan">
        <label>Tags:</label>
      </span>
      <label class="tagsLabel">{{ entityLine.tags }}</label>
    </div>
    <div class="inputRow">
      <span class="labelSpan">
        <label>Quantity:</label>
      </span>
      <input class="standardTextBox inputField" [readonly]="preventUpdate()" [(ngModel)]="entityLine.quantity"/>
    </div>
    @if (isStockUnit()) {
      <div class="inputRow">
        <span class="labelSpan"></span>
        <label class="tagsLabel">Quick Stock and Quick Deal units are serialized, so each line is one unit.</label>
      </div>
    }
  </div>
  <div mat-dialog-actions>
    <span class="spacer"></span>
    <span>
      <button matButton="elevated" (click)="cancel()">{{ preventUpdate() ? 'Close' : 'Cancel' }}</button>
      @if (!preventUpdate()) {
        <button matButton="elevated" (click)="saveAndClose()">Save</button>
      }
    </span>
  </div>
</div>

